module.exports = __webpack_public_path__ + "img/IMG_2399_T_L_Wood.8493e0f2.jpg";